import GetIcon from "../font-awesome-icon";
import { Tooltip, Box, Typography, styled } from "@mui/material";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .MuiTooltip-tooltip`]: {
    padding: "10px 14px",
    backgroundColor: "var(--palette-stroke)",
    color: "var(--primary)",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    fontSize: "0.875rem",
  },
});

const ColumnTitle = (props) => {
  const { title = "", tooltip = "", tootltipText = "", icon = null } = props;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        position: "absolute",
        height: "100%",
        width: "calc(100% - 5px)",
        overflow: "hidden",
        zIndex: "99999999",
        top: 0,
        // px: 1,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: "500" }}>
        {title}
      </Typography>
      <LightTooltip
        title={
          <Box>
            <Typography variant="h6" gutterBottom color={"custom.text"}>
              {title}
            </Typography>
            <Typography variant="body2" color={"custom.text"}>
              {tooltip}
            </Typography>
          </Box>
        }
      >
        <Box
          sx={{
            border: "1px solid var(--palette-grey_text)",
            color: "var(--palette-grey_text)",
            width: 16,
            height: 16,
            flex: "0 0 16px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <GetIcon
            icon={icon}
            iconStyles={{ width: "8px", height: "8px", marginRight: 0 }}
          />
        </Box>
      </LightTooltip>
    </Box>
  );
};

export default ColumnTitle;
